import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Router, Route } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import { loadAppConfig, setLoading } from './AppState';
import { getUrlParamsFromUrl } from '../../../maptool/components/UrlUtils';
import Config from '../../Config';

import App from './App';

export const history = createBrowserHistory();

class AppContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.routeParams = this.routeParams.bind(this);
    this.getChildContext = this.getChildContext.bind(this);
  }

  getChildContext() {
    return {
      refresh: () => {
        if (window.$) {
          window.$(`#${Config.adDiv}`).appendTo(window.$(`#${Config.adDivWrapper}`));
        }
        this.props.dispatch(setLoading(true));
        window.maptoolapp.rerender();
      }
    };
  }


  componentWillMount() {
    this.props.dispatch(loadAppConfig());
  }

  routeParams(matchProps) {
    const urlParams = getUrlParamsFromUrl(matchProps);

    return (
      <App {...this.props} {...matchProps} {...urlParams} />
    );
  }

  render() {
    return (
      <Router history={history}>
        <div>
          <Route path="/wetterkarten/:productId?/:stateId?/" render={this.routeParams} />
        </div>
      </Router>
    );
  }
}

AppContainer.childContextTypes = {
  refresh: React.PropTypes.func
};

export default connect(state => state.AppState)(AppContainer);



/** WEBPACK FOOTER **
 ** ./apps/maptool/modules/App/AppContainer.js
 **/